<template>
    <div
        class="relative w-full"
        :style="{ 'padding-bottom': 100 / ratio + '%' }"
    >
        <div class="absolute top-0 left-0 w-full">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        ratio: { default: 1 }
    }
};
</script>
